import { StyleSheet } from 'react-native';
export var getWithLottieStyles = () => {
  return StyleSheet.create({
    container: {
      position: 'relative'
    },
    lottie: {
      position: 'absolute',
      height: '100%',
      width: '100%',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 99
    }
  });
};